// Text-message consent from Account settings (backend: POST /api/sms/consent,
// routes/signup_routes.py). Recorded before the number goes to Cognito.
import axios from 'axios';
import { baseApi } from '../../API/api';
import { authHeaders } from '../../utils/authHeader';
import { CONSENT_VERSION } from './smsConsent';

/** Records the ticked box; resolves to the number as E.164, as the backend normalized it. */
export async function recordSmsConsent(phone) {
  const { data } = await axios.post(
    `${baseApi}/api/sms/consent`,
    { phone, consent_version: CONSENT_VERSION },
    { headers: await authHeaders() },
  );
  return data.phone;
}
